export default "__VITE_ASSET__rehW3ZPU__"